<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      title         = "XXMAC"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                <!-- DROPDOWN -->
                <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown>

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import navMenuItems        from "@/layouts/components/vertical-nav-menu/navMenuItems.js"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
// import firebase from '@/services/saleData'
// import moment from "moment-timezone";
// import _ from 'lodash';
export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu
  },
  data() {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems      : navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
    },
    navMenuItems: {
      immediate: true,
      handler(value) {
          for(const x in value){
            for(const xx in value[x].items){
              /*if(value[x].items[xx].icon !== undefined && value[x].items[xx].icon == "UserIcon"){
                value[x].items[xx].tag =3;
                value[x].items[xx].tagColor ='success';
              }*/
              if(value[x].items[xx].role !== undefined && (value[x].items[xx].role !== this.activeUserInfo.role)) {
                value[x].items.splice(xx, 1);
              }
            }
          }
      }
    }
  },
  computed: {
    statement(){
      return this.$store.state.statementManagement.statement
    },
    withdraw(){
      return this.$store.state.historyManagement.withdraw
    },
    deposit(){
      return this.$store.state.historyManagement.deposit
    },
     slip(){
      return this.$store.state.historyManagement.slip
    },
    pushbullet(){
      return this.$store.state.statementManagement.pushbullet
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  },
  async created() {
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    // const created = firebase.database().ref('users');
    // created.on("child_changed", snapshot => {
    //   this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    // });
    // created.on("child_added", (snapshot) => {
    //   if(snapshot.val().createdate){
    //     const createdate = snapshot.val().createdate.split(' ');
    //     const time = createdate[1].split(':');
    //     const date = createdate[0]+' '+time[0]+':'+time[1];
    //     if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //       const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/newuser.mp3');
    //       audio.volume = 0.7;
    //       audio.play();
    //       this.$store.dispatch('userManagement/fetchAddUsers',{user:snapshot.val(),key:snapshot.key}).catch(err => { console.error(err) });
    //     }
    //   }
    // });
    //deposit
    //const users = (await firebase.database().ref(`/users`).once('value')).val();
    // const users = [];
    // for(const x in _users){
    //   users[_users[x].userId] = _users[x];
    // }
    // let deposits = (this.deposit.length>0)?this.deposit:[];
    // firebase.firestore().collection("history").where("type", "==", "ฝาก").orderBy('createdate','desc').limit(500)
    // .onSnapshot(async (snapshot) => {
    //      const data = [];
    //     snapshot.docChanges().forEach((change) => {
    //       data[change.doc.id] = change.doc.data();
    //       data[change.doc.id].typedata = change.type;
    //       data[change.doc.id].qty = Number(change.doc.data().qty.toString().replace(/,/g,''));
    //     });
    //     for(const x in data){
    //       if (data[x].typedata === "added") {
    //         const deposit = data[x];
    //         if(!users[deposit.userId]){
    //             const _users = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(deposit.userId).once('value')).val();
    //             let user = [];
    //             for(const x in _users){
    //               user = _users[x];
    //               user.key = x;
    //             }
    //             users[deposit.userId] = user;
    //         }
    //         if(users[deposit.userId] && users[deposit.userId].code){
    //           const createdate = deposit.createdate.split(' ');
    //           const time = createdate[1].split(':');
    //           const date = createdate[0]+' '+time[0]+':'+time[1];
    //           if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //             const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/deposit.mp3');
    //             audio.volume = 0.7;
    //             audio.play();
    //           }
    //           const user = users[deposit.userId];
    //           deposit.key = x;
    //           deposit.linename = user.linename;
    //           deposit.firstname = user.firstname;
    //           deposit.lastname = user.lastname;
    //           deposit.bank = user.bank;
    //           deposit.account_no = user.account_no;
    //           deposit.code = user.code;
    //           deposit.pictureUrl = user.pictureUrl;
    //           deposits.push(deposit);
    //         }
    //       }
    //       if (data[x].typedata === "modified") {
    //           const value = data[x];
    //           const keyUser = _.findKey(deposits, function(o) { return o.key === x; });
    //           if(keyUser){
    //             const deposit =  deposits[keyUser];
    //             deposit.qty = Number(value.qty.toString().replace(/,/g,''));
    //             deposit.status = value.status;
    //             deposit.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //             deposits.splice(keyUser, 1);
    //             deposit.key = x;
    //             deposits.splice(keyUser, 0, deposit);
    //           }
    //       }
    //     }
    //     if(deposits.length > 0){
    //       deposits = _.orderBy(deposits, ['createdate'],['desc']);
    //       this.$store.commit('historyManagement/SET_DEPOSIT', deposits);
    //     }
    // });

    //withdraw
    // let withdraws = (this.withdraw.length>0)?this.withdraw:[];
    // firebase.firestore().collection("history").where("type", "==", "ถอน").orderBy('createdate','desc').limit(500)
    // .onSnapshot(async (snapshot) => {
    //     const data = [];
    //     snapshot.docChanges().forEach((change) => {
    //       data[change.doc.id] = change.doc.data();
    //       data[change.doc.id].typedata = change.type;
    //       data[change.doc.id].qty = Number(change.doc.data().qty.toString().replace(/,/g,''));
    //     });
    //     for(const x in data){
    //       if (data[x].typedata === "added") {
    //         const withdraw = data[x];
    //         const createdate = withdraw.createdate.split(' ');
    //         const time = createdate[1].split(':');
    //         const date = createdate[0]+' '+time[0]+':'+time[1];
    //         if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //           const audio = new Audio('https://firebasestorage.googleapis.com/v0/b/arena789-line.appspot.com/o/images%2Fmixkit-fail-drum-and-bells-571.wav?alt=media&token=d158c256-687d-4883-ba51-08098f2cc8aa');
    //           audio.volume = 0.7;
    //           audio.play();
    //         }
    //         if(!users[withdraw.userkey]){
    //             const user = (await firebase.database().ref(`/users/${withdraw.userkey}`).once('value')).val();
    //             if(user){
    //             user.key = withdraw.userkey;
    //             users[withdraw.userkey] = user;
    //             }
    //         }
    //         if(users[withdraw.userkey] && users[withdraw.userkey].code){
    //           const user = users[withdraw.userkey];
    //           withdraw.key = x;
    //           withdraw.linename = user.linename;
    //           withdraw.firstname = user.firstname;
    //           withdraw.lastname = user.lastname;
    //           withdraw.bank = user.bank;
    //           withdraw.account_no = user.account_no;
    //           withdraw.code = user.code;
    //           withdraw.pictureUrl = user.pictureUrl;
    //           withdraw.admin_name = (withdraw.employee)?withdraw.employee.email:'';
    //           withdraws.push(withdraw);
    //         }
    //       }
    //       if (data[x].typedata === "modified") {
    //           const value = data[x]
    //           const keyUser = _.findKey(withdraws, function(o) { return o.key === x; });
    //           if(keyUser){
    //             const withdraw =  withdraws[keyUser];
    //             withdraw.qty = Number(value.qty.toString().replace(/,/g,''));
    //             withdraw.status = value.status;
    //             withdraw.admin_name = (value.employee)?value.employee.email:'';
    //             withdraw.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //             withdraws.splice(keyUser, 1);
    //             withdraw.key = x;
    //             withdraws.splice(keyUser, 0, withdraw);
    //           }
    //       }
    //     }
    //     if(withdraws.length > 0){
    //       withdraws = _.orderBy(withdraws, ['createdate'],['desc']);
    //       this.$store.commit('historyManagement/SET_WITHDRAW', withdraws);
    //     }
    // });

    // //statement
    // let statements = (this.statement.length>0)?this.statement:[];
    // firebase.firestore().collection("krungsri").where("type", "==", "ฝาก").orderBy('date','desc').limit(500)
    // .onSnapshot(async (snapshot) => {
    //     const data = [];
    //     snapshot.docChanges().forEach((change) => {
    //       data[change.doc.id] = change.doc.data();
    //       data[change.doc.id].typedata = change.type;
    //       data[change.doc.id].qty = Number(change.doc.data().qty.toString().replace(/,/g,''));
    //     });
    //     for(const x in data){
    //       if (data[x].typedata === "added") {
    //         const statement = data[x];
    //        // console.log(statement);
    //         if(statement.createdate){
    //           const createdate = statement.createdate.split(' ');
    //           const time = createdate[1].split(':');
    //           const date = createdate[0]+' '+time[0]+':'+time[1];
    //           if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //             const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/statement.mp3');
    //             audio.volume = 0.7;
    //             audio.play();
    //             setTimeout(() => {
    //               audio.play();
    //             }, 1000);
    //           }
    //         }
    //         if(!users[statement.userkey] && statement.userkey){
    //             const user2 = (await firebase.database().ref(`/users/${statement.userkey}`).once('value')).val();
    //             if(user2){
    //               user2.key = statement.userkey;
    //               users[statement.userkey] = user2;
    //             }
    //         }
    //         if(users[statement.userkey] && users[statement.userkey].code){
    //           const user = users[statement.userkey];
    //           statement.key = x;
    //           if(!statement.firstname_lastname){
    //             if(user.firstname && user.lastname)
    //               statement.firstname_lastname = user.firstname+' '+user.lastname;
    //             else if(user.firstname)
    //               statement.firstname_lastname = user.firstname
    //             else 
    //               statement.firstname_lastname = '';
    //           }
    //           statement.firstname = user.firstname;
    //           statement.lastname = user.lastname;
    //           statement.bank = user.bank;
    //           statement.account_no = user.account_no;
    //           statement.code = user.code;
    //           statement.pictureUrl = user.pictureUrl;
    //           statement.createdate = statement.date;
    //           statements.push(statement);
    //         }else{
    //           statement.key = x;
    //           statement.linename = '';
    //           if(statement.detail){
    //             statement.firstname_lastname = statement.detail;
    //           }else{
    //             statement.firstname_lastname = '';
    //           }
    //           statement.firstname = '';
    //           statement.lastname = '';
    //           statement.account_no = statement.bank;
    //           statement.bank = '';
    //           statement.code = '';
    //           statement.pictureUrl = '';
    //           statement.createdate = statement.date;
    //           statements.push(statement);
    //         }
    //       }
    //       if (data[x].typedata === "modified") {
    //           const value = data[x];
    //           const keyUser = _.findKey(statements, function(o) { return o.key === x; });
    //           if(keyUser){
    //             const statement =  statements[keyUser];
    //             statement.qty = Number(value.qty.toString().replace(/,/g,''));
    //             statement.status = value.status;
    //             statement.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //             statement.createdate = value.date;
    //             statement.bonus = value.bonus;
    //             statement.code = value.code;
    //             statement.userkey = value.userkey;
    //             statement.user = value.user;
    //             statement.bank = value.bank;
    //             //statement.firstname_lastname = value.firstname+' '+value.lastname;
    //             statement.accountno = value.accountno;
    //             statement.turncredit = (value.turncredit)?value.turncredit:'';
    //             statement.canwithdraw = (value.canwithdraw)?value.canwithdraw:'';
    //             statements.splice(keyUser, 1);
    //             statement.key = x;
    //             statements.splice(keyUser, 0, statement);
    //           }
    //       }
    //       if (data[x].typedata === 'removed') {
    //         const keyUser = _.findKey(statements, function(o) { return o.key === x; });
    //         if(keyUser){
    //            statements.splice(keyUser, 1);
    //         }
    //       }
    //     }
    //     if(statements.length > 0){
    //       statements = _.orderBy(statements, ['createdate'],['desc']);
    //       this.$store.commit('statementManagement/SET_STATEMENT', statements);//commit('SET_STATEMENT', statements);
    //     }
    // });

    // let slips = (this.slip.length>0)?this.slip:[];
    //   firebase.firestore().collection("slip").where('createdate','>=',moment().tz("Asia/Bangkok").add(-2,'days').format("YYYY-MM-DD HH:mm")).orderBy('createdate','desc').limit(500)
    //   .onSnapshot(async (snapshot) => {
    //       const data = [];
    //       snapshot.docChanges().forEach((change) => {
    //         data[change.doc.id] = change.doc.data();
    //         data[change.doc.id].typedata = change.type;
    //       });
    //       for(const x in data){
    //         if (data[x].typedata === "added") {
    //           const slip = data[x];
    //           slip.key = x;
    //         // console.log(statement);
    //           if(slip.createdate){
    //             const createdate = slip.createdate.split(' ');
    //             const time = createdate[1].split(':');
    //             const date = createdate[0]+' '+time[0]+':'+time[1];
    //             if(date === moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm")){
    //               const audio = new Audio('https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/statement.mp3');
    //               audio.volume = 0.7;
    //               audio.play();
    //               setTimeout(() => {
    //                 audio.play();
    //               }, 1000);
    //             }
    //           }
    //           if(!users[slip.userkey]){
    //               const user = (await firebase.database().ref(`/users/${slip.userkey}`).once('value')).val();
    //               if(user){
    //                 user.key = slip.userkey;
    //                 users[slip.userkey] = user;
    //               }
    //           }
    //           if(users[slip.userkey] && users[slip.userkey].code){
    //             const user = users[slip.userkey];
    //             slip.key = x;
    //             //withdraw.linename = user.linename;
    //             slip.firstname = user.firstname;
    //             slip.lastname = user.lastname;
    //             slip.bank = user.bank;
    //             slip.account_no = user.account_no;
    //             slip.code = user.code;
    //             slip.pictureUrl = user.pictureUrl;
    //             slip.admin_name = (slip.employee)?slip.employee.email:'';
    //             slip.bonus = user.bonus;
    //             slips.push(slip);
    //           }
    //         }
    //         if (data[x].typedata === "modified") {
    //             const value = data[x]
    //             const keyUser = _.findKey(slips, function(o) { return o.key === x; });
    //             if(keyUser){
    //               const slip =  slips[keyUser];
    //               slip.status = value.status;
    //               slip.image = value.image;
    //               slip.admin_name = (value.employee)?value.employee.email:'';
    //               slip.updatetime = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
    //               slips.splice(keyUser, 1);
    //               slip.key = x;
    //               slips.splice(keyUser, 0, slip);
    //             }
    //         }
    //       }
    //       if(slips.length > 0){
    //         slips = _.orderBy(slips, ['createdate'],['desc']);
    //         this.$store.commit('historyManagement/SET_SLIP', slips);//commit('SET_STATEMENT', statements);
    //       }
    //   });


    //   let lines = [];
    //   firebase.firestore().collection("otp2").orderBy('createdate','desc').limit(100).onSnapshot(async (snapshot) => {
    //       const dataline = [];
    //       snapshot.docChanges().forEach((change) => {
    //         dataline[change.doc.id] = change.doc.data();
    //         dataline[change.doc.id].type = change.type;
    //       });
    //       for(const x in dataline){
    //         if (dataline[x].type === "added") {
    //           const line = dataline[x];
    //           line.key = x;
    //           if(line.typedata === 'line' && line.otp){
    //             const d = line.otp.split(' ');
    //             if(d.length === 21){
    //               line.date = d[14]+' '+d[15];
    //             }else if(d.length === 18){
    //               line.date = d[11]+' '+d[12];
    //             }
    //             lines.push(line);
    //           }else if(line.typedata === 'sms' && line.otp){
    //             const d = line.otp.split(' ');
    //             if(d.length === 4 || d.length === 5){
    //               line.date = d[0];
    //               lines.push(line);
    //             }
    //           }
    //         }
    //       }
    //       if(lines.length > 0){
    //         lines = _.orderBy(lines, ['createdate'],['desc']);
    //         this.$store.commit('report/SET_LINE', lines);//commit('SET_STATEMENT', statements);
    //       }
    //   });
    // const pushbullet = this.pushbullet;
    // var websocket;
    // if (websocket != null) {
    //     websocket.close();
    // }
    // websocket = new WebSocket('wss://stream.pushbullet.com/websocket/o.OeO8Ahc2y2xMFXVh9DsoqNyT3fl0TWXm');
    // websocket.onopen = () => {
    //     console.log("<p>WebSocket onopen</p>");
    // }
    // websocket.onmessage = (e) => {
    //     const data = JSON.parse(e.data);
    //     if(data.push){
    //       console.log(data.push.body);
    //       pushbullet.push({id:data.push.notification_id,text:data.push.body});
    //       this.$store.commit('statementManagement/SET_PUSHBULLET', pushbullet);//commit('SET_STATEMENT', statements);
    //     }
    // }
    // websocket.onerror = () => {
    //     console.log("<p>WebSocket onerror</p>");
    // }
    // websocket.onclose = () => {
    //   console.log("<p>WebSocket onclose</p>");
    // }
    //https://connected-pub.s3-ap-southeast-1.amazonaws.com/happily/coins.mp3
  }
}

</script>

